import { c as _c } from "react/compiler-runtime";
import { Item, ItemAvatar, ItemContent, ItemSide, ItemTitle } from "@opensea/next-ui-kit";
import { classNames, tv } from "@opensea/ui-kit";
const moreMenuItemVariants = tv({
  base: "rounded-xl border-0 bg-transparent px-3 focus:outline-hidden",
  variants: {
    isSheet: {
      false: "px-3 py-4",
      true: "px-2 py-3"
    }
  }
});
function MoreMenuItem(t0) {
  const $ = _c(14);
  let children;
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      isSheet: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const isSheet = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== className || $[6] !== isSheet) {
    t2 = classNames(moreMenuItemVariants({
      isSheet
    }), className);
    $[5] = className;
    $[6] = isSheet;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children) {
    t3 = <div>{children}</div>;
    $[8] = children;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== rest || $[11] !== t2 || $[12] !== t3) {
    t4 = <Item asChild={true} className={t2} interactive={true} {...rest}>{t3}</Item>;
    $[10] = rest;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export { MoreMenuItem, ItemAvatar as MoreMenuItemAvatar, ItemContent as MoreMenuItemContent, ItemTitle as MoreMenuItemTitle, ItemSide as MoreMenuItemSide };